// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const VOYAGES_AGENTs='VOYAGES_AGENTs';
export const ACTIVITIES_LIST = 'ACTIVITIES_LIST';
export const CARGO = 'CARGO';
export const CALL = 'CALL';
export const NEW_PASSWORD = 'NEW_PASSWORD';